import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const OrganizationCardsWrapper = styled.div`
  display: flex;
  gap: ${Spacing.S16};
  justify-content: center;
  position: relative;
`
export const ConnectIconWrapper = styled.div`
  padding: ${Spacing.S4} ${Spacing.S6};
  border-radius: ${Spacing.S12};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${Color.Grey150};
`
